/**
 * PDP desktop scroll linking.
 *
 * On desktop the product grid is a full-height, two-column layout: a sticky
 * image column and a product information column that scrolls inside itself.
 * Scrolling with the cursor over the image column used to scroll the page,
 * so the add to cart button (which sits below the fold inside the information
 * column) could be scrolled straight past without ever coming into view.
 *
 * This makes the wheel drive the information column first, wherever the cursor
 * is within the grid, and hands scrolling back to the page once that column
 * has reached the end in the direction of travel.
 *
 * Only runs at the breakpoint where the two-column layout exists.
 */
(function () {
  var BREAKPOINT = 1068;
  var EDGE = 2; // px tolerance for "at the end" and viewport fit
  var grid = null;
  var info = null;

  function isDesktop() {
    return window.matchMedia('(min-width: ' + BREAKPOINT + 'px)').matches;
  }

  /* Wheel deltas arrive in pixels, lines or pages depending on the device. */
  function deltaPixels(event) {
    if (event.deltaMode === 1) return event.deltaY * 16;
    if (event.deltaMode === 2) return event.deltaY * (info ? info.clientHeight : window.innerHeight);
    return event.deltaY;
  }

  function canScroll(el, delta) {
    var max = el.scrollHeight - el.clientHeight;
    if (max <= EDGE) return false;
    return delta > 0 ? el.scrollTop < max - EDGE : el.scrollTop > EDGE;
  }

  /* Only take over while the grid is the thing filling the viewport. Outside
     that the page should scroll normally, which is also what brings the grid
     back into view when scrolling up. */
  function gridFillsViewport() {
    var rect = grid.getBoundingClientRect();
    return rect.top <= EDGE && rect.bottom >= window.innerHeight - EDGE;
  }

  /* Leave genuinely scrollable things under the cursor alone, e.g. a thumbnail
     rail or a scrolling panel inside the gallery. */
  function hasScrollableAncestor(target, delta) {
    var node = target;
    while (node && node !== grid && node.nodeType === 1) {
      if (node !== info && canScroll(node, delta)) {
        var overflow = getComputedStyle(node).overflowY;
        if (overflow === 'auto' || overflow === 'scroll') return true;
      }
      node = node.parentNode;
    }
    return false;
  }

  function onWheel(event) {
    if (event.ctrlKey) return; // pinch zoom
    if (!isDesktop()) return;
    if (!info || !info.isConnected) return;

    var delta = deltaPixels(event);
    if (!delta) return;

    /* Cursor already inside the information column: let the browser scroll it,
       and let its native scroll chaining move the page at the end. */
    if (info.contains(event.target)) return;

    if (!gridFillsViewport()) return;
    if (hasScrollableAncestor(event.target, delta)) return;
    if (!canScroll(info, delta)) return; // hand back to the page

    event.preventDefault();
    info.scrollTop += delta;
  }

  function init() {
    grid = document.querySelector('.product-grid-container');
    if (!grid) return;
    info = grid.querySelector('.product-information');
    if (!info) return;
    grid.addEventListener('wheel', onWheel, { passive: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
